<template>
    <div>
        <Box title="入库明细">
            <div class="detailWrap">
                <!-- 单号信息头 -->
                <div class="dhHeader">
                    <span class="dhLabel">入库单号</span>
                    <span class="dhValue">{{ DH }}</span>
                </div>

                <!-- 加载中 -->
                <div class="loadingBox" v-if="loading">
                    <van-loading color="#4FA69E" size="40px" />
                </div>

                <!-- 空状态 -->
                <div class="emptyBox" v-else-if="list.length === 0">
                    <van-empty description="暂无明细数据" />
                </div>

                <!-- 设备列表 -->
                <div v-else class="items IsLoad" v-for="(item, index) in list" :key="index">
                    <div class="itemTopBox">
                        <div>
                            <span>设备编号</span>
                            <span>{{ item.SBMCBH }}</span>
                        </div>
                        <div>
                            <span>设备名称</span>
                            <span>{{ item.SBMC }}</span>
                        </div>
                        <div>
                            <span>规格型号</span>
                            <span>{{ item.SBGG }}</span>
                        </div>
                        <div>
                            <span>数量</span>
                            <span>{{ item.SL }}</span>
                        </div>
                        <div>
                            <span>单价</span>
                            <span>{{ item.CGDJ }}</span>
                        </div>
                        <div>
                            <span>总金额</span>
                            <span>{{ item.ZJE }}</span>
                        </div>
                    </div>
                    <div class="itemBottomBox">
                        <div class="btn-view" @click="viewEquipmentDetail(item)">查看详情</div>
                    </div>
                </div>
            </div>
        </Box>
    </div>
</template>

<script>
    import Box from '@/components/commonBox/commonBox'
    import {
        Loading,
        Empty
    } from 'vant'

    export default {
        name: 'RKDetailInfo',
        components: {
            Box,
            [Loading.name]: Loading,
            [Empty.name]: Empty
        },
        data() {
            return {
                DH: this.$route.params.DH || '',
                list: [],
                loading: true
            }
        },
        mounted() {
            if (this.DH) {
                this.loadData();
            } else {
                this.loading = false;
            }
        },
        methods: {
            loadData() {
                this.loading = true;
                this.$post('api/CheckIncoming/GetRKDetailInfo', {
                    Token: '123456789',
                    DH: this.DH
                }).then(result => {
                    // 兼容列表字段名：RKDetailList 或 rows
                    this.list = result.Rows || [];
                    this.loading = false;
                }).catch(() => {
                    this.loading = false;
                });
            },
            viewEquipmentDetail(item) { // 查看详情 → 调 GetAcceptanceByDH 后跳设备验收信息只读页
                this.$get('api/CheckIncoming/LoadPutInInfo', {
                    DH: item.YCDH,
                    SBBH: item.SBMCBH,
                    Token: 'YTDF5EF3A6174564E5981A446158F106'
                }).then(result => {
                    // 兼容单条或数组返回
                    const data = Array.isArray(result) ? result[0] : (result.data ? result.data[0] : result);
                    if (!data) {
                        this.$Toast('数据异常，请联系管理员!');
                        return;
                    }
                    // 处理日期字段
                    const dateFields = ['CCRQ', 'QDRQ', 'GRRQ', 'YSHGRQ', 'BXRQ', 'SSRQ', 'ZBRQ',
                        'TZGHSJ', 'JHJZRQ', 'SCYSRQ', 'ECYSRQ', 'JSSCSJ', 'LZSJ', 'AZRQ', 'FPRQ'
                    ];
                    dateFields.forEach(f => {
                        if (data[f] === '1900-01-01') data[f] = '';
                    });

                    this.$router.push({
                        name: 'EquipmentAcceptanceDetails',
                        params: {
                            AcceptanceInfoList: data,
                            AZYS: (data.AZYSQK || '').split(','),
                            IsAddOrUpdata: true, // true：已有数据，触发图片加载
                            PageState: true, // true：只读模式，隐藏保存按钮
                        }
                    });
                });
            }
        }
    }
</script>

<style scoped lang="scss">
    .detailWrap {
        padding-top: 10px;
    }

    .dhHeader {
        display: flex;
        align-items: center;
        background: $BACKGROUND-COLOR;
        border-radius: 12px;
        padding: 28px 30px;
        margin-bottom: 20px;
        font-size: 28px;

        .dhLabel {
            color: #858585;
            flex: 1;
        }

        .dhValue {
            color: $TEXT-DARK-COLOR;
            font-weight: bold;
        }
    }

    .loadingBox {
        display: flex;
        justify-content: center;
        padding: 80px 0;
    }

    .emptyBox {
        padding: 60px 0;
    }

    .items {
        background: $BACKGROUND-COLOR;
        border-radius: 16px;
        margin-bottom: 20px;
        padding: 36px 30px;

        .itemTopBox {
            border-bottom: 2px solid #eee;

            div {
                display: flex;
                align-items: center;
                font-size: 28px;
                margin-bottom: 32px;

                span:first-child {
                    flex: 1;
                    color: #858585;
                }

                span:last-child {
                    color: $TEXT-DARK-COLOR;
                    font-weight: bold;
                    width: 326px;
                    text-align: right;
                }
            }
        }

        .itemBottomBox {
            margin-top: 32px;
            display: flex;
            align-items: center;
            justify-content: center;

            .btn-view {
                width: 60%;
                height: 80px;
                border-radius: 8px;
                text-align: center;
                line-height: 80px;
                font-size: 26px;
                background: $THEME-COLOR;
                color: #fff;
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/page/rkDetailInfo/rkDetailInfo.vue